<template>
    <div class="car-item-large" is="Default" :data="data" :v-lazy="vLazy" :width="280"></div>
</template>

<script>
    import Default from './Default.vue';
    export default {
        props: {
            data: {
                type: Object,
                /**
                 * 默认车辆对象
                 * @Author   Bolt
                 * @DateTime 2017-03-09T20:49:53+0800
                 * @return   {[type]}                 [description]
                 */
                default() {
                    return {}
                },
                /**
                 * 校验车辆对象
                 * @Author   Bolt
                 * @DateTime 2017-03-09T20:49:41+0800
                 * @param    {[type]}                 value [description]
                 * @return   {[type]}                       [description]
                 */
                validator(value) {
                    return true;
                }
            },
            'v-lazy': null
        },
        components: {
            Default
        }
    }
</script>

<style lang="less" scoped>
    .car-item-large {
        width: 280px;
        height: 372px;
        // 无弹个车标且无售价 -22px -29px;
        &.line-height-level-0 {
            height: 372px - 22px - 29px;
        }
        // 无售价 -22px
        &.line-height-level-1 {
            height: 372px - 22px;
        }
        &.line-height-level-2 {
            height: 372px;
        }
    }
</style>



// WEBPACK FOOTER //
// Large.vue?335d5058